<script>
import Layout from "../../layouts/main";
import CustomerApi from "@/services/customers-api";
import DetailsCustomer from "@/components/details-customer";
import NotesCustomer from "@/components/notes-customer";

export default {
    components: {
        Layout, DetailsCustomer, NotesCustomer
    },
    props: {
        customerId:{
            type:Number,
            default: null
        },

      },

    mounted(){
        this.findCustomerById()
    },


    data(){
        return{
            customer:null,
        }
    },
    methods:{
        findCustomerById(){
        CustomerApi.findCustomerById(this.customerId).then(response=>{
            if(response){
                this.customer = response
            }
        })
    },




}}
</script>

<template>
    <Layout>

        <div class="card mr-sm-5 ml-sm-5">
            <div class="card-body">
                            <h2 class="card-title font-size-25 pb-4 text-dark text-uppercase" style="font-size:2em;">{{ $t('customer.card.title') }}</h2>
                    
                    <DetailsCustomer :customer="customer"/>
                
                    

                   

                  <!-- </b-tab>

                <b-tab  class="border-0 "  lazy @click="activeTab=1">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                        <i class="fas fa-sticky-note font-size-16 pr-2"/>
                        </span>
                        <i class="d-none d-sm-inline-block fas fa-sticky-note  font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{ $t('customer.tabs.tab2') }}  </span>
                    </template>

                   


                  </b-tab>
                  



                
              </b-tabs> -->

          </div>
        </div>

        <hr style="width:60%;" class="mt-5 mb-5"/>

        <NotesCustomer class="pr-sm-5 ml-sm-5" v-if="customer" :customerId="customer == null ? null : customer.id" />



        
    </Layout>
</template>